import { Maybe, just, nothing } from 'maybeasy';
import { action, makeObservable, observable } from 'mobx';
import { SearchParameter } from '../../ListFilter/Types';
import { StringOption } from '../Options/Types';
import {
  LearningCollectionSummariesResource,
  LearningCollectionsState,
  changePage,
  ready,
  resetSearchParameters,
  updateLearningCollectionsList,
  updatingOrganizationParameters,
  updatingSearchParameters,
  updatingSortParameters,
  waiting,
} from './Types';

class LearningCollectionsStore {
  @observable
  state: LearningCollectionsState = waiting();

  @observable
  recentlyClonedCollectionId: Maybe<number> = nothing();

  @observable
  recentlyUpdatedAccessCollectionId: Maybe<number> = nothing();

  constructor() {
    makeObservable(this);
  }

  @action
  collectionCloned = (id: number) => {
    this.recentlyClonedCollectionId = just(id);
  };

  @action
  clearRecentlyCloned = () => {
    this.recentlyClonedCollectionId = nothing();
  };

  @action
  collaboratorAccessUpdated = (id: number) => {
    this.recentlyUpdatedAccessCollectionId = just(id);
  };

  @action
  clearRecentlyUpdatedAccess = () => {
    this.recentlyUpdatedAccessCollectionId = nothing();
  };

  @action
  ready = (data: Maybe<LearningCollectionSummariesResource>) => {
    this.state = ready(this.state, data);
  };

  @action
  changingPage = (page: number) => {
    if (this.state.kind === 'ready') {
      this.state = changePage(this.state, page);
    }
  };

  @action
  updateLearningCollectionsList = () => {
    if (this.state.kind === 'ready') {
      this.state = updateLearningCollectionsList(this.state);
    }
  };

  @action
  updatingSearchParameters = (searchParameter: SearchParameter) => {
    if (this.state.kind === 'ready') {
      this.state = updatingSearchParameters(searchParameter, this.state);
    }
  };

  @action
  updatingSortParameters = (searchParameter: SearchParameter) => {
    if (this.state.kind === 'ready') {
      this.state = updatingSortParameters(searchParameter, this.state);
    }
  };

  @action
  updatingOrganizationParameters = (option: StringOption) => {
    if (this.state.kind === 'ready') {
      this.state = updatingOrganizationParameters(this.state, option);
    }
  };

  @action
  resetSearchParameters = () => {
    if (this.state.kind === 'ready') {
      this.state = resetSearchParameters(this.state);
    }
  };
}

export default LearningCollectionsStore;
